import { standard, ThemeContext, Toaster } from '@creditas-ui/react';
import { BrowserRouter } from 'react-router-dom';
import { GlobalContext } from '@/shared/infrastructure/context';
import { MainLayout } from '@/shared/ui';
import { ApolloProvider } from '@apollo/client';
import { apolloClient } from '@/shared/infrastructure/clients/apollo';
import { Router } from './Router';

const App = (): JSX.Element => {
  return (
    <BrowserRouter>
      <ThemeContext.Provider value={{ ...standard }}>
        <GlobalContext>
          <ApolloProvider client={apolloClient}>
            <MainLayout>
              <Router />
              <Toaster />
            </MainLayout>
          </ApolloProvider>
        </GlobalContext>
      </ThemeContext.Provider>
    </BrowserRouter>
  );
};

export default App;
